module.exports = __webpack_public_path__ + "img/Hyundai.003ac410.jpg";